import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SummaryItems } from 'fc-ui-components';

import { Observable } from 'rxjs';

import { ProductDetailsSummaryService } from './providers/product-details-summary.service';
import { ReorderArticle } from 'app/b2b-order/types/reorder';
import { OrderProductDetailService } from 'app/b2b-order/services/order-product-detail';

@Component({
    selector: 'fc-product-details-summary',
    templateUrl: './product-details-summary.component.html',
    styleUrls: ['./product-details-summary.component.less'],
    providers: [ProductDetailsSummaryService],
    standalone: false
})
export class ProductDetailsSummaryComponent {
    constructor(
        private productDetailsSummaryService: ProductDetailsSummaryService,
        public orderProductDetailService: OrderProductDetailService
    ) {}

    @Input() set articles(articles: ReorderArticle[]) {
        this.summaryArticles = articles;
        this.summary = this.productDetailsSummaryService.productSummary(this.summaryArticles);
    }
    @Input() checkStock = true;

    @Output() onClick = new EventEmitter<void>();

    public summaryArticles: ReorderArticle[];
    public summary: Observable<SummaryItems>;

    public buttonEnabled() {
        const hasSelectedProducts = !this.orderProductDetailService.noArticleSelectedForOrder(this.summaryArticles);
        if (!this.checkStock) {
            return hasSelectedProducts;
        }
        return this.orderProductDetailService.allArticleAmountsValid(this.summaryArticles) && hasSelectedProducts;
    }
}
